import { Provider, Signal } from "@angular/core";
import { ATOM_SECTION_HEADING_BACK_LABEL } from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

/**
 * Localizes the default back icon-button of `atom-section-heading`.
 *
 * Token is a `Signal<string>` and stays in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}.
 */
export const provideAtomSectionHeadingLabels = (): Provider[] => [
    {
        provide: ATOM_SECTION_HEADING_BACK_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal("atom_section_heading.back_label"),
    },
];
